import React from 'react';
import {get, isNil} from 'lodash';
import className from 'classnames';
import moment from 'moment';
import pluralize from 'pluralize';

import {
  canEdit,
} from '../lib/policies';

import {
  useModal,
} from '../hooks';

import UserWithImage from './UserWithImage';
import ImageLoader from './ImageLoader';
import PostsListImageModal from './PostsListImageModal';
import PostsListVideoModal from './PostsListVideoModal';
import YoutubePost from './YoutubePost';
import ModalDelete from './ModalDelete';
import PostsListItemVideo from './PostsListItemVideo'

const PostsListItem = ({
  post,
  isAReply = false,
  renderCheckBox,
}) => {
  const [
    modal,
    modalSet,
    $submitButton,
  ] = useModal({
    keyboardBindings: true,
  })

  const onToggleModal = (data) => () => {
    modalSet(data)
  }

  const [
    modalVideo,
    modalVideoSet,
    $submitButtonVideo,
  ] = useModal({
    keyboardBindings: true,
  })

  const onToggleModalVideo = (data) => () => {
    modalVideoSet(data)
  }

  return (
    <div
      className={className('Posts__item__wrapper', {
        'Posts__item__wrapper--has-a-reply': get(post, 'inReplyToPost'),
        'Posts__item__wrapper--is-a-reply': isAReply,
      })}
    >
      {renderCheckBox(post)}

      <div className='Posts__item__a__wrapper'>
        <a
          className='Posts__item__a'
          href={`/${gon.currentProvider}/posts/${get(post, 'id')}`}
        >
          {get(post, 'id')}
        </a>

        {isAReply &&
          <a
            className='Posts__item__a__bottom'
            href={`/${gon.currentProvider}/posts?conversation_id=${get(post, 'conversationId')}`}
          >
            See all
          </a>
        }
      </div>

      <div className='ImageBorder'>
        <ImageLoader
          klassName='Posts__item__image'
          url={get(post, 'user.profileIcon.thumb.url')}
        />
      </div>

      <div className='Posts__item__right'>
        <div className='Posts__item__right__top'>
          <div className='Posts__item__right__top__left'>
            <UserWithImage
              hideImage
              user={get(post, 'user')}
            />

            {(() => {
              let type

              switch (get(post, 'postType')) {
                case 'call':
                  type = <span className='Posts__item__right__top__p__call'>Made a call</span>
                  break
                case 'image':
                  type = <span>Made image post</span>
                  break
                case 'youtube':
                  type = <span>Posted youtube link</span>
                  break
                case 'video':
                  type = <span>VDO post</span>
                  break
              }

              if (!type) return null

              return (
                <p className='Posts__item__right__top__p'>{type}</p>
              )
            })()}

            {(get(post, 'inReplyToPost')) &&
              <p className='Posts__item__right__top__p'>
                <span>Re: <a href={`/${gon.currentProvider}/posts/${get(post, 'inReplyToPost.id')}`}>{get(post, 'inReplyToPost.id')}</a></span>
              </p>
            }

            {(get(post, 'shareable')) &&
              <p className='Posts__item__right__top__p'>
                {get(post, 'shareable.shareableType') === 'Post' ?
                  <span>Repost from post <a href={`/${gon.currentProvider}/posts/${get(post, 'shareable.id')}`}>{get(post, 'shareable.id')}</a></span>
                :
                  <span>Repost from group <a href={`/${gon.currentProvider}/groups/${get(post, 'shareable.id')}`}>{get(post, 'shareable.id')}</a></span>
                }
              </p>
            }

            {(get(post, 'isPinned')) &&
              <p className='Posts__item__right__top__p'>
                <span className='Posts__item__right__top__p__pinned'>Pinned</span>
              </p>
            }
          </div>

          {canEdit('Post') &&
            <div className='Posts__item__right__top__controls'>
              <a
                className='Posts__item__right__top__controls__a Posts__item__right__top__controls__a--pencil'
                href={`/${gon.currentProvider}/posts/${get(post, 'id')}/edit`}
              />

              <ModalDelete
                type='post'
                id={get(post, 'id')}
                klassName='Posts__item__right__top__controls__a Posts__item__right__top__controls__a--trash'
                reload
                hideText
              />

              {get(post, 'postType') === 'image' &&
                <a
                  title='Remove images'
                  className='Posts__item__right__top__controls__a Posts__item__right__top__controls__a--x-sq'
                  onClick={onToggleModal(get(post, 'id'))}
                />
              }

              {get(post, 'postType') === 'video' &&
                <a
                  title='Remove video'
                  className='Posts__item__right__top__controls__a Posts__item__right__top__controls__a--x-sq'
                  onClick={onToggleModalVideo(get(post, 'id'))}
                />
              }
            </div>
          }
        </div>

        <div className='Posts__item__right__middle'>
          {get(post, 'postType') === 'youtube' ? <YoutubePost post={post} /> : get(post, 'text', '')}
          {get(post, 'postType') === 'image' && get(post, 'images.length') > 0 &&
            <div className='Posts__item__right__middle__images__wrapper'>
              <div className='Posts__item__right__middle__images'>
                {get(post, 'images', []).map((image, i) => (
                  <a
                    key={i}
                    href={get(image, 'url')}
                    target='_blank'
                  >
                    <img
                      key={i}
                      src={get(image, 'url')}
                    />
                  </a>
                ))}
              </div>

              <PostsListImageModal
                isActive={modal == get(post, 'id')}
                onToggleModal={onToggleModal()}
                post={post}
                $submitButton={$submitButton}
              />
            </div>
          }

          {get(post, 'postType') === 'video' && get(post, 'videos.length') > 0 &&
            <div className='Posts__item__right__middle__videos__wrapper'>
              <div className='Posts__item__right__middle__videos'>
                {get(post, 'videos', []).map((video, i) => (
                  <PostsListItemVideo
                    key={i}
                    video={video}
                  />
                ))}
              </div>

              <PostsListVideoModal
                isActive={modalVideo == get(post, 'id')}
                onToggleModal={onToggleModalVideo()}
                post={post}
                $submitButton={$submitButtonVideo}
              />
            </div>
          }

          {get(post, 'shareable.shareableType') === 'Post' &&
            <div className='Posts__item__right__middle__reply'>
              <UserWithImage
                user={get(post, 'shareable.user')}
              />

              {get(post, 'shareable.postType') === 'youtube' ?
                <YoutubePost post={get(post, 'shareable')} />
              :
                <React.Fragment>
                  {get(post, 'shareable.text') &&
                    <p>{get(post, 'shareable.text')}</p>
                  }
                </React.Fragment>
              }

              {get(post, 'shareable.postType') === 'image' && get(post, 'shareable.images.length') > 0 &&
                <div className='Posts__item__right__middle__images__wrapper'>
                  <div className='Posts__item__right__middle__images'>
                    {get(post, 'shareable.images', []).map((image, i) => (
                      <a
                        key={i}
                        href={get(image, 'url')}
                        target='_blank'
                      >
                        <img
                          key={i}
                          src={get(image, 'url')}
                        />
                      </a>
                    ))}
                  </div>
                </div>
              }
            </div>
          }

          {get(post, 'shareable.shareableType') === 'Group' &&
            <div className='Posts__item__right__middle__group-share'>
              <ImageLoader
                url={get(post, 'shareable.coverImage.thumb.url')}
              />

              <div className='Posts__item__right__middle__group-share__right'>
                <h5 className='Posts__item__right__middle__group-share__right__h5'>{get(post, 'shareable.topic')}</h5>
                <p className='Posts__item__right__middle__group-share__right__p'>
                  {get(post, 'shareable.groupsUsersCount')} {pluralize('member', get(post, 'shareable.groupsUsersCount'))}
                </p>
              </div>
            </div>
          }

          {!isNil(get(post, 'sharedUrl')) &&
            <a href={post.sharedUrl.url} target="_blank" rel="noopener noreferrer">
              <div className='Posts__item__right__middle__link-preview'>
                <ImageLoader url={post.sharedUrl.imageUrl} renderAsImg />
                <div className='Posts__item__right__middle__link-preview__right'>
                  <h5 className='Posts__item__right__middle__link-preview__right__h5'>{post.sharedUrl.title}</h5>
                  <p className='Posts__item__right__middle__link-preview__right__p'>
                    {post.sharedUrl.url}
                  </p>
                </div>
              </div>
            </a>
          }
        </div>

        <div className='Posts__item__right__bottom'>
          <div className='Posts__item__right__bottom__left'>
            <time><strong>Created at</strong> {moment(get(post, 'createdAt')).format('YYYY-MM-DD HH:mm')}</time>
            {get(post, 'groupId') &&
              <span><strong>Group ID</strong> <a className='Posts__item__a' href={`/${gon.currentProvider}/groups/${get(post, 'groupId')}`}>{get(post, 'groupId')}</a></span>
            }
          </div>

          <span className='Posts__item__right__bottom__span'>
            <strong>Reported count</strong> {get(post, 'reportedCount')}
          </span>
        </div>
      </div>
    </div>
  );
}

export default PostsListItem;
